import { render, staticRenderFns } from "./SetBox.vue?vue&type=template&id=f9fb2b52&scoped=true&"
import script from "./SetBox.vue?vue&type=script&lang=js&"
export * from "./SetBox.vue?vue&type=script&lang=js&"
import style0 from "./SetBox.vue?vue&type=style&index=0&id=f9fb2b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fb2b52",
  null
  
)

export default component.exports